export default __webpack_public_path__ + "images/VY.944122d.png";